import React from 'react';
export function UpsellSection() {
  return null;
}